<template>
  <div id="transfers">
    <modal
      name="modal_transfer_0"
      :adaptive="true"
      height="auto"
      :scrollable="true"
    >
      <div id="modal_transfer_0_body" class="col sized-top-10">
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="form_phone">Celular do destinatário:</label>
              <input
                v-model="form_phone"
                type="tel"
                v-mask="'(##) #########'"
                class="form-control"
                id="form_phone"
                aria-describedby="phoneHelp"
                placeholder="digite aqui"
              />
              <small
                id="phoneHelp"
                v-bind:class="
                  (form_phone == ''
                    ? 'text-muted'
                    : validatePhone(form_phone, false)
                    ? 'text-success'
                    : 'text-danger') + ' form-text'
                "
                >*
                {{
                  form_phone == ''
                    ? 'Celular do destinatário'
                    : validatePhone(form_phone, true)
                }}</small
              >
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <label for="form_value">Valor:</label>
              <input
                v-model.lazy="form_value"
                v-money="money"
                type="tel"
                class="form-control"
                id="form_value"
                aria-describedby="valueHelp"
                placeholder="digite aqui"
              />
              <small
                id="valueHelp"
                v-bind:class="
                  (form_value == 'R$ 0.00'
                    ? 'text-muted'
                    : validateValue(form_value, false)
                    ? 'text-success'
                    : 'text-danger') + ' form-text'
                "
                >*
                {{
                  form_value == 'R$ 0.00'
                    ? 'Valor para transferência'
                    : validateValue(form_value, true)
                }}</small
              >
            </div>
          </div>
        </div>
        <div class="row sized-bottom-10">
          <div class="col aling-center">
            <button
              type="button"
              class="btn btn-dark"
              v-bind:disabled="!validate()"
              v-on:click="confirmTransfer"
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    </modal>
    <modal
      name="modal_transfer_1"
      :adaptive="true"
      height="auto"
      :scrollable="true"
    >
      <div
        id="modal_transfer_1_body"
        class="col sized-top-10"
        v-if="user_receipt != null"
      >
        <div class="row">
          <div class="col aling-center">
            Você confirma a transferência de saldo?
          </div>
        </div>
        <div class="row sized-top-10">
          <div class="col aling-center">
            <div id="imgProfile"></div>
          </div>
        </div>
        <div class="row sized-top-10">
          <div class="col aling-center">
            <span class="text-bold"
              >R${{ this.form_value_valid.toFixed(2) }}</span
            >
            <span> para </span>
            <span class="text-bold">{{ user_receipt.displayName }}</span>
          </div>
        </div>
        <div class="row sized-top-10 sized-bottom-10">
          <div class="col aling-center">
            <button
              type="button"
              class="btn btn-dark"
              v-on:click="finalizeTransfer"
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    </modal>
    <div class="col">
      <div class="row" v-if="balance > 0.1 && is_loading == false">
        <div class="col aling-center">
          <button type="button" class="btn btn-dark" v-on:click="sendTransfer">
            Enviar saldo
          </button>
        </div>
      </div>
      <div class="sized-top-20" v-if="is_loading == true">
        <div class="loader"></div>
      </div>
      <div
        class="row sized-top-20"
        v-else-if="transfers_receipt.length > 0 || transfers_send.length > 0"
      >
        <div class="col">
          <ul class="nav nav-tabs">
            <li v-if="transfers_receipt.length > 0">
              <a
                class="nav-link"
                ref="nav_active0"
                data-toggle="tab"
                href="#receipt"
                >Recebidas</a
              >
            </li>
            <li v-if="transfers_send.length > 0">
              <a
                class="nav-link"
                ref="nav_active1"
                data-toggle="tab"
                href="#send"
                >Enviadas</a
              >
            </li>
          </ul>
          <div class="tab-content">
            <div
              id="receipt"
              class="tab-pane fades"
              v-if="transfers_receipt.length > 0"
            >
              <div class="row">
                <div class="col">
                  <Transfer
                    class="sized-top-20"
                    v-for="transfer in transfers_receipt"
                    :key="transfer.key"
                    v-bind:transfer="transfer"
                  />
                </div>
              </div>
            </div>
            <div
              id="send"
              class="tab-pane fades"
              v-if="transfers_send.length > 0"
            >
              <div class="row">
                <div class="col">
                  <Transfer
                    class="sized-top-20"
                    v-for="transfer in transfers_send"
                    :key="transfer.key"
                    v-bind:transfer="transfer"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sized-top-20 aling-center" v-else>
        <span class="text-bold"
          >Você ainda não fez nenhuma transferência, comece agora mesmo!</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { VMoney } from 'v-money';
import { firebase, db, functions } from '../configs/firebase.js';
import Transfer from '../components/Transfer.vue';

export default {
  name: 'Transfers',
  data() {
    return {
      form_phone: '',
      form_phone_valid: '',
      form_value: '',
      form_value_valid: 0,
      user_receipt: null,
      is_loading: false,
      transfers_receipt: [],
      transfers_send: [],
      money: {
        decimal: '.',
        thousands: '',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true
      }
    };
  },
  directives: { money: VMoney },
  components: {
    Transfer
  },
  computed: {
    user: function () {
      return this.$root.user;
    },
    balance: function () {
      try {
        return this.$root.user_data.counter.balance;
      } catch (e) {
        return 0;
      }
    }
  },
  methods: {
    sendTransfer() {
      this.$modal.show('modal_transfer_0');
    },
    async confirmTransfer() {
      try {
        this.is_loading = true;

        this.$modal.hide('modal_transfer_0');

        let payload = {
          phone: this.form_phone_valid
        };

        let checkUserByPhone = functions.httpsCallable('checkUserByPhone');
        let result = await checkUserByPhone(payload);

        if (result.data == 'empty') {
          alert('Usuário inexistente no aplicativo, cheque o número digitado');
        } else {
          this.user_receipt = result.data;

          if (this.user_receipt.photoURL != null) {
            this.$el.style.setProperty(
              '--photo-img',
              'url(' + this.user_receipt.photoURL + ')'
            );
          } else {
            this.$el.style.setProperty(
              '--photo-img',
              'url(https://urbanodelivery.com.br/img_avatar.png)'
            );
          }

          this.$modal.show('modal_transfer_1');
        }
      } catch (e) {
        //console.log(e);
      } finally {
        this.is_loading = false;
      }
    },
    async finalizeTransfer() {
      try {
        this.is_loading = true;

        this.$modal.hide('modal_transfer_1');

        let payload = {
          receipt: this.user_receipt.uid,
          receipt_name: this.user_receipt.displayName,
          receipt_phone: this.user_receipt.phoneNumber,
          send: this.user.uid,
          send_name: this.user.displayName,
          send_phone: this.user.phoneNumber,
          value: this.form_value_valid,
          dates: { create: firebase.database.ServerValue.TIMESTAMP }
        };

        await db.ref('transfers').push().set(payload);

        alert(
          'Transferência realizada com sucesso, ela está na sua lista de transferências'
        );
      } catch (e) {
        //console.log(e);
      } finally {
        this.form_value = 'R$ 0.00';
        this.form_value_valid = 0;
        this.form_phone = '';
        this.form_phone_valid = '';

        this.is_loading = false;

        this.getTransfers();
      }
    },
    validateValue(value, r) {
      let v = parseFloat(value.replace('R$ ', ''));

      if (v > 0.1) {
        if (v < this.balance) {
          this.form_value_valid = v;
          return r ? 'Valor válido' : true;
        } else {
          this.form_value_valid = 0;
          return r ? 'Você não possui esse valor' : false;
        }
      }
      this.form_value_valid = 0;
      return r ? 'Valor inválido' : false;
    },
    validatePhone(phone, r) {
      let x = phone.replace(/[^0-9]+/g, '');

      if (x.length == 11) {
        let n = '+55' + x;

        if (n == this.user.phoneNumber) {
          return r ? 'Esse é o seu número' : false;
        }

        this.form_phone_valid = n;
        return r ? 'Número válido' : true;
      }

      this.form_phone_valid = '';
      return r ? 'Número inválido' : false;
    },
    validate() {
      if (this.form_phone_valid.length > 0 && this.form_value_valid > 0) {
        return true;
      } else {
        return false;
      }
    },
    async getTransfers() {
      try {
        this.is_loading = true;

        this.transfers_receipt = [];
        this.transfers_send = [];

        let q_transfers_receipt = await db
          .ref('transfers')
          .orderByChild('receipt')
          .equalTo(this.user.uid)
          .limitToLast(50)
          .once('value');

        q_transfers_receipt.forEach((s_transfer) => {
          let transfer = {
            key: s_transfer.key,
            data: s_transfer.val()
          };

          this.transfers_receipt.push(transfer);
        });

        let q_transfers_send = await db
          .ref('transfers')
          .orderByChild('send')
          .equalTo(this.user.uid)
          .limitToLast(50)
          .once('value');

        q_transfers_send.forEach((s_transfer) => {
          let transfer = {
            key: s_transfer.key,
            data: s_transfer.val()
          };

          this.transfers_send.push(transfer);
        });
      } catch (e) {
        //console.log(e);
      } finally {
        this.transfers_receipt.sort(function (x, y) {
          return y.data.dates.create - x.data.dates.create;
        });

        this.transfers_send.sort(function (x, y) {
          return y.data.dates.create - x.data.dates.create;
        });

        this.is_loading = false;
      }
    }
  },
  watch: {
    is_loading() {
      this.$nextTick(() => {
        try {
          this.$refs.nav_active0.click();
        } catch (e) {
          try {
            this.$refs.nav_active1.click();
          } catch (e) {
            //console.log(e);
          }
        }
      });
    }
  },
  created() {
    this.getTransfers();
  }
};
</script>

<style>
#transfers {
  text-align: left;
  margin: 20px auto;
  max-width: 912px;
}

.nav-tabs li a {
  color: black;
}

.tab-pane {
  padding: 10px;
}

#imgProfile {
  position: relative;
  left: calc(50% - 75px);
  border-radius: 50%;
  width: 150px;
  height: 150px;
  background-image: var(--photo-img);
  background-size: 100% 100%;
  cursor: pointer;
}

@media only screen and (max-width: 912px) {
  #transfers {
    width: 100%;
    padding: 0px;
  }
}
</style>
